/* PACKAGES */
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

/* ANIMATION */
import { animation } from "config";

/* DATA */
import pricingPlans from "data/websiteDB";

/* MATERIAL TAILWIND COMPONENTS */
import { Button } from "@material-tailwind/react";

const HomePricing = () => {
  return (
    <motion.div
      variants={animation}
      className="py-10 xl:py-20 lg:py-20 bg-[#F5F5F5]"
    >
      <div className="container">
        <div className="grid grid-cols-1 xl:grid-cols-3 lg:grid-cols-3 gap-y-10 xl:gap-20 lg:gap-20">
          <div className="col-span-1">
            <h5 className="text-base font-source font-semibold text-logo">
              COMPREHENSIVE PACKAGES
            </h5>
            <h2 className="text-2xl xl:text-3xl lg:text-3xl font-roundo font-bold text-black mt-5 leading-snug">
              Choose the Right Plan to Power Your Complete Alumni Network
            </h2>
          </div>
          <div className="col-span-2">
            <div className="grid grid-cols-1 xl:grid-cols-3 lg:grid-cols-3 gap-5">
              {pricingPlans.map((plan, index) => {
                return (
                  <div key={index} className="col-span-1">
                    <div className="bg-white border border-[#E5E5E5] rounded-lg shadow p-5">
                      <h5 className="text-xl font-roundo font-bold text-black">
                        {plan.name}
                      </h5>
                      <p className="mt-2 text-base font-source font-normal text-greyText">
                        {plan.description}
                      </p>
                      <Link to="/pricing" className="mt-5 block">
                        <Button className="shadow-none normal-case hover:shadow-none bg-logo hover:bg-logo/80 transition-all duration-300 ease-in-out rounded-md px-5 py-2.5 text-sm font-source font-medium text-white">
                          View details
                        </Button>
                      </Link>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default HomePricing;
